/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetAIConfigRequest = {
  projectKey: string;
  configKey: string;
};

/** @internal */
export const GetAIConfigRequest$inboundSchema: z.ZodType<
  GetAIConfigRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  projectKey: z.string(),
  configKey: z.string(),
});
/** @internal */
export type GetAIConfigRequest$Outbound = {
  projectKey: string;
  configKey: string;
};

/** @internal */
export const GetAIConfigRequest$outboundSchema: z.ZodType<
  GetAIConfigRequest$Outbound,
  z.ZodTypeDef,
  GetAIConfigRequest
> = z.object({
  projectKey: z.string(),
  configKey: z.string(),
});

export function getAIConfigRequestToJSON(
  getAIConfigRequest: GetAIConfigRequest,
): string {
  return JSON.stringify(
    GetAIConfigRequest$outboundSchema.parse(getAIConfigRequest),
  );
}
export function getAIConfigRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetAIConfigRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetAIConfigRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetAIConfigRequest' from JSON`,
  );
}
